import React from 'react';
import styles from '../ManagePage.module.css';
import { getAsinThumbnailUrl } from '../../Tools/dealCheckerHistoryUtils';
import { formatScoreDate } from './SingleScoreCard';

// Deal-tag check card for the Manage page — same stacked layout as BulkScoreCard,
// with active-deal and product counts instead of ASIN pills.
const DealTagCard = ({ batch, onClick }) => {
    const asins = batch.results.map((r) => r.asin).filter(Boolean);
    const productCount = new Set(asins).size;
    const activeDeals = batch.results.filter((r) => r.deal_present).length;
    const first = batch.results.find((r) => r.main_image || r.asin);
    const previewImage = first ? (first.main_image || getAsinThumbnailUrl(first.asin)) : null;

    return (
        <div
            className={`${styles.generationCardBulk} ${styles.stackedBulkCard}`}
            onClick={onClick}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(); } }}
        >
            <div className={styles.generationCardBulkLayer1}></div>
            <div className={styles.generationCardBulkLayer2}></div>
            <div className={styles.generationCardBulkMain}>
                <div className={styles.recentProjectInner}>
                    <div className={styles.cardImage}>
                        {previewImage ? (
                            <img
                                src={previewImage}
                                alt="Deal tag batch preview"
                                className={styles.recentProjectImageBulk}
                                loading="lazy"
                                onError={(e) => {
                                    e.target.onerror = null;
                                    if (first?.asin) e.target.src = getAsinThumbnailUrl(first.asin);
                                }}
                            />
                        ) : (
                            <div className={styles.imagePlaceholder}>No Image</div>
                        )}
                    </div>
                    <div className={styles.recentProjectDetails}>
                        <div className={styles.recentProjectDetailsTop}>
                            <div className={styles.activeDealsRow}>
                                <span className={styles.activeDealsBar} />
                                <span>{activeDeals} Active Deal{activeDeals !== 1 ? 's' : ''}</span>
                            </div>
                            <div className={styles.dealProductsCount}>
                                {productCount} Product{productCount !== 1 ? 's' : ''}
                            </div>
                        </div>
                        <div className={styles.cardDate}>
                            <span>{formatScoreDate(batch.date)}</span>
                        </div>
                    </div>
                </div>
                <div className={styles.recentProjectScoreBadgeBulk}>
                    <span>Deal Tag</span>
                </div>
            </div>
        </div>
    );
};

export default DealTagCard;
